export const StorageKeys = {
    ModuleIds: 'moduleIds',
    AccessRightIds: 'accessRightIds',
    IsExternalToken: 'is-external-token',
    UserProfile: 'userProfile',
    CultureName: 'cultureName'
};
